import React, {useState, useMemo} from 'react'
import {default as Apiservices} from '../../../../../../src/common/index'
import {useNavigate} from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import {ToastContainer, toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import BackDrop from '../../timesheetentry/ComponentBackdrop'
import {useTable, ColumnInstance} from 'react-table'
import {ListProjects} from '../../../../modules/apps/user-management/users-list/table/columns/_columns'
import {
  useQueryResponseData,
  useQueryResponseLoading,
} from '../../../../modules/apps/user-management/users-list/core/QueryResponseProvider'
import moment from 'moment'

export default function InvFrequencyPop(props: any) {
  const [show, setShow] = useState(true)
  const [showBackDrop, setShowBackDrop] = useState(true)
  const users = useQueryResponseData()
  const data = useMemo(() => users, [users])
  const columns = useMemo(() => ListProjects, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })
  const handleClose = () => {
    setShow(false)
    props.close(false)
    props.setShow(false)
    props.setSubmitOpen(false)
    props.setSubmitShow(false)
    props.setSubmitAllOpen(false)
    props.setSubmitAllShow(false)
  }
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby='contained-modal-title-vcenter'
        centered
        backdrop='static'
        keyboard={false}
      >
        {props.view_open && (
          <div className='col-auto'>
            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={props.cancel}
            ></button>
          </div>
        )}
        <Modal.Header>
          <Modal.Title>Invoicing Frequency History</Modal.Title>
          <button
            type='button'
            className='btn-close'
            onClick={props.invoiceFreqHistoryClose}
            data-bs-dismiss='modal'
            aria-label='Close'
          ></button>
        </Modal.Header>
        <Modal.Body>
          {props.projectid && props?.projectid?.invoicing_frequency_history?.length > 0 && (
            <>
              <table
                id='kt_table_users'
                className='table table-row-bordered table-row-gray-300 gy-3 gs-4 freezeTable freezeTable2'
                {...getTableProps()}
              >
                <thead>
                  <tr className='fw-bold fs-7 text-gray-600 text-uppercase'>
                    <th className='  py-4'>Old Value </th>
                    <th className='  py-4'>New Value </th>
                    <th className='  py-4'>Updated By </th>
                    <th className='  py-4'>Updated Date </th>
                  </tr>
                </thead>
                {props.projectid && props?.projectid?.invoicing_frequency_history?.length > 0 ? (
                  <>
                    <tbody className='' {...getTableBodyProps()}>
                      {props.projectid && props?.projectid?.invoicing_frequency_history?.length > 0
                        ? props.projectid &&
                          props?.projectid?.invoicing_frequency_history?.map(
                            (user: any, index: number) => {
                              return (
                                <tr
                                  key={index}
                                  className='namepage text-dark fw-semibold  fs-7 text-nowrap'
                                >
                                  <td className=''>{user.old_value ? user.old_value : '-'}</td>
                                  <td className=''>{user.new_value ? user.new_value : '-'}</td>
                                  <td className=''>
                                    {user.changed_by_name ? user.changed_by_name : '-'}
                                  </td>
                                  <td className=''>
                                    {user.changed_at
                                      ? moment(user.changed_at).format('MM/DD/YYYY,HH:mm:ss')
                                      : '-'}
                                  </td>
                                </tr>
                              )
                            }
                          )
                        : ''}
                    </tbody>
                  </>
                ) : (
                  ''
                )}
              </table>
            </>
          )}
          <div className='d-flex justify-content-center gap-3 py-2'>
            {props.submit_open && (
              <>
                <div className=''>
                  <button
                    className='btn btn-sm  btn-primary'
                    onClick={(e) => props.handleSubmitted(e, props.index)}
                  >
                    Ok
                  </button>
                </div>
                <div className=''>
                  <button className='btn btn-sm btn-danger' onClick={props.modalPop}>
                    Cancel
                  </button>
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
      <ToastContainer />
    </>
  )
}
